export default __webpack_public_path__ + "static/1.1_FR-2403ae0b205d8ee37f07ce670ddf580a.png";